var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconDownload(_a) {
    var size = _a.size, colorVariant = _a.colorVariant, onClick = _a.onClick, icon = _a.icon, theme = _a.theme, additionalProps = __rest(_a, ["size", "colorVariant", "onClick", "icon", "theme"]);
    var iconTheme = useContext(ThemeContext);
    var color = setColor(iconTheme, colorVariant, 'secondary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", __assign({}, additionalProps, { width: renderSize, height: renderSize, viewBox: "0 0 100 100", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { transform: "translate(8.000000, 15.000000)" },
                React.createElement("path", { d: "M84,44.52 L84,61.32 C84,65.9591919 80.2391919,69.72 75.6,69.72 L8.4,69.72 C3.7608081,69.72 0,65.9591919 0,61.32 L0,44.52 L8.4,44.52 L8.4,59.22 C8.4,60.2638183 9.16156364,61.1297638 10.1593691,61.2925145 L10.5,61.32 L73.5,61.32 C74.5438183,61.32 75.4097638,60.5584364 75.5725145,59.5606309 L75.6,59.22 L75.6,44.52 L84,44.52 Z", id: "box", fill: color, fillRule: "nonzero" }),
                React.createElement("g", { transform: "translate(27.435379, 0.000000)", stroke: color, strokeLinecap: "square", strokeWidth: "8" },
                    React.createElement("line", { x1: "14.5646212", y1: "-3.55271368e-15", x2: "14.5646212", y2: "42" }),
                    React.createElement("line", { x1: "22.1246212", y1: "26.88", x2: "22.1246212", y2: "47.88", transform: "translate(22.124621, 37.380000) rotate(45.000000) translate(-22.124621, -37.380000) " }),
                    React.createElement("line", { x1: "-1.42108547e-14", y1: "29.9553788", x2: "14.8492422", y2: "44.8046211" }))))));
}
//# sourceMappingURL=icon.download.component.js.map